import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    id: 1,
    name: "Kita Young",
    rating: 5,
    text: "JP Joinery are currently working in our home and have been absolutely amazing. Can't thank you enough!"
  },
  {
    id: 2,
    name: "Rob Lambert",
    rating: 5,
    text: "New kitchen doors supplied and fitted – amazing job at competitive pricing, highly recommended!"
  },
  {
    id: 3,
    name: "Sandra Malaspina",
    rating: 5,
    text: "JPJoinery fitted a new worktop, sink and tap in my kitchen. I found Josh to be very helpful and was quick with the fitting. I am pleased with the end result."
  },
  {
    id: 4,
    name: "Linda Burton",
    rating: 5,
    text: "Josh is an excellent joiner I've used him to do several jobs for me as well as replacing all my kitchen cupboard doors at a fraction of the price of new kitchen. Looks fab - he is very good at turning up when he says he is, very competitive prices and very friendly. Highly recommended!"
  },
  {
    id: 5,
    name: "Lisa Baxter",
    rating: 5,
    text: "JP Joinery stepped in when we'd been let down by another tradesperson, and Joshua worked really hard completing our wooden floor, skirting boards and re-hanging doors. He turned up when he said, made suggestions for staying within budget, worked very hard all day and also was a good price, not to forget very nice and pleasant! Highly recommend Josh for all your joinery needs!"
  },
  {
    id: 6,
    name: "Bailey",
    rating: 5,
    text: "I had JPJoinery come and fit me a new kitchen in my house and it looks great!! They turned up on time, work hard and very polite. They really do deserve your business."
  },
  {
    id: 7,
    name: "Charlie Olsson",
    rating: 5,
    text: "Would highly recommend Josh for any joinery work, he provided an excellent service and fantastic craftsmanship. Very happy with how it turned out."
  },
  {
    id: 8,
    name: "Dan Field",
    rating: 5,
    text: "Excellent job, extremely happy with Josh and his work. Will send photos once I've had the walls repainted and windows done."
  },
  {
    id: 9,
    name: "Graham Collins",
    rating: 5,
    text: "Fitted 9 new internal doors recently. A superb job was done and delighted with the results. Very efficient! Just recommended to a family member and new project agreed."
  },
  {
    id: 10,
    name: "Kelly Beech",
    rating: 5,
    text: "Had my stair bannister done today, what a lovely guy and a fantastic job. Removed my old one and fitted a glass and oak bannister in one day. Even with my little 4 year old checking on him with his own hammer. Nothing was too much trouble. Would definitely recommend."
  }
];

export const Reviews = () => {
  return (
    <section id="reviews" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#1c2536]/10 rounded-full mb-4 sm:mb-6">
            <span className="text-[#1c2536] font-semibold text-xs sm:text-sm">TESTIMONIALS</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            What Our Customers Say
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            Don't just take our word for it - hear from our satisfied customers
          </p>
          
          {/* Overall Rating */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="text-gray-900 font-bold text-lg sm:text-xl">5.0</span>
            <span className="text-gray-500 text-sm sm:text-base">from Google Reviews</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {reviews.map((review) => (
            <Card 
              key={review.id} 
              className="bg-white border-gray-200 hover:border-[#1c2536]/30 hover:shadow-lg transition-all duration-300"
            >
              <CardContent className="p-4 sm:p-6">
                {/* Quote Icon */}
                <Quote className="w-8 h-8 text-[#1c2536]/20 mb-3" />
                
                {/* Stars */}
                <div className="flex mb-3">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
                
                {/* Review Text */}
                <p className="text-gray-600 text-sm sm:text-base mb-4 leading-relaxed">
                  "{review.text}"
                </p>
                
                {/* Reviewer Info */}
                <div className="pt-4 border-t border-gray-100">
                  <p className="font-semibold text-gray-900 text-sm sm:text-base">{review.name}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-8 sm:mt-10 md:mt-12 text-center">
          <a 
            href="https://www.google.com/search?q=JP+Joinery+Hull+reviews"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#1c2536] hover:text-[#1c2536]/80 font-semibold transition-colors"
          >
            <span>See all reviews on Google</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
